import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const isAuthenticated = useSelector((state) => state.Auth.isAuthenticated);
  const navigate = useNavigate();

  // Authenticated users land on the work list; everyone else returns to sign in.
  const homePath = isAuthenticated ? "/work" : "/";

  return (
    <div className="w-screen min-h-screen flex flex-col items-center justify-center bg-backgroundColor px-[20px]">
      <p className="font-OpenSansBold text-[80px] text-blueColor leading-none">404</p>
      <p className="font-OpenSansSemiBold text-[22px] text-titleColor mt-[16px]">Page Not Found</p>
      <p className="font-OpenSansRegular text-[14px] text-subTitleColor mt-[8px] text-center max-w-[420px]">
        The page you are looking for doesn’t exist or may have been moved.
      </p>
      <button
        type="button"
        onClick={() => navigate(homePath)}
        className="font-OpenSansSemiBold text-[14px] text-white bg-blueColor rounded-[8px] px-[24px] py-[10px] mt-[28px]"
      >
        Back to Home
      </button>
    </div>
  );
};

export default NotFound;
